import { Inject } from '@odinjs/odin';

import Controller, { OnAfterFetch, OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FieldAPI, PanelAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';

import { ApplicationRoute } from '../../../constants/routes';
import BaseController from '../../BaseController';
import { FragmentNames, ProfileAliases } from '../../../codegen';

type ProfileData = {
  dsEmail: string;
  dtUltimoAcesso: string;
  nmUsuario: string;
}
@Controller({ component: ProfileAliases.PANEL_PROFILE, fragment: FragmentNames.PROFILE })
export default class ProfileController extends BaseController {

  @Inject(ProfileAliases.TEXT_LAST_ACESS)
  private textLastAccessApi!: TextAPI;

  @Inject(ProfileAliases.FIELD_USER_EMAIL)
  private fieldUserEmail!: FieldAPI;

  @Inject(ProfileAliases.PANEL_FOOTER_PROFILE)
  private panelLastAccessApi!: PanelAPI;

  @OnAfterFetch(ProfileAliases.FETCH_PROFILE)
  handleAfterFetchProfile({ data }: FetchEvent): void {
    const { dtUltimoAcesso, dsEmail } = data as ProfileData;
    this.fieldUserEmail.setVisible(!!dsEmail);
    if (!dtUltimoAcesso) {
      this.panelLastAccessApi.setVisible(false)
      return
    }
    const formatDate = ModelService.format('date', dtUltimoAcesso, { type: 'timestamp' });
    const lastAcess = MessageService.translate('profile.last-acess-text');
    this.textLastAccessApi.setValue(MessageService.translate(`${lastAcess}: ${formatDate}`));
  }

  @OnClick(ProfileAliases.LINK_TERMS_LIST)
  onClickLink(): void {
    this.historyService.push(ApplicationRoute.USER_TERMS_LIST);
  }
}